import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { Button } from 'src/components/ui/button';
import { ProjectSettingFields } from 'src/pages/ControlDeskPage/ProjectControls/ProjectSettingsModal/ProjectSettingFields';

export const ProjectSettingsModal = ({ disabled = false }) => {
  const [open, setOpen] = useState(false);

  const closePopup = () => {
    setOpen(false);
  };

  return (
    <Dialog onOpenChange={setOpen} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        <Button
          variant="outline"
          className={clsx(disabled && 'pointer-events-none opacity-50', 'flex gap-2')}
        >
          <p className="font-medium text-base-xs">Edit</p>
          <svg
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.44444 12.0532H2.46567L9.19244 5.3155L8.17122 4.29261L1.44444 11.0303V12.0532ZM13 13.5H0V10.4306L9.70306 0.711801C9.83849 0.576185 10.0222 0.5 10.2137 0.5C10.4052 0.5 10.5888 0.576185 10.7243 0.711801L12.7674 2.75829C12.9028 2.89395 12.9789 3.07791 12.9789 3.26973C12.9789 3.46155 12.9028 3.64551 12.7674 3.78117L4.50883 12.0532H13V13.5ZM9.19244 3.26973L10.2137 4.29261L11.2349 3.26973L10.2137 2.24685L9.19244 3.26973Z"
              fill="#05050D"
              fillOpacity="0.8"
            />
          </svg>
        </Button>
      </DialogTrigger>
      <DialogContent closeButtonHidden className="pb-0">
        <DialogHeader>
          <DialogTitle className="opacity-80 text-lg font-medium font-jamjuree">
            Project Settings
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 pt-4">
          <ProjectSettingFields close={closePopup} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
